import React from 'react';
import { isProduction } from '../../utils/isProduction';
import { SecondaryButton } from '../connectedForm/Button';
import ErrorInfo from '../ErrorInfo';
import { useHistory } from 'react-router';
import { SentryUserFeedbackModal } from './SentryUserFeedbackModal';
import { FallbackRender } from '@sentry/react/build/types/errorboundary';

const SentryFallback = ({
  error,
  componentStack,
  onClose,
}: {
  error: unknown;
  componentStack: string;
  onClose?: () => void;
}) => {
  const history = useHistory();

  const onClickBack = () => {
    if (onClose) {
      onClose();
    } else {
      history.goBack();
    }
  };

  if (isProduction()) {
    return (
      <>
        <div style={{ padding: '0 10px' }}>
          <h1>Something unexpected happened</h1>
          <p>Please try again. If the problem persists please contact support.</p>
          <SecondaryButton onClick={onClickBack} inline>
            Go Back
          </SecondaryButton>
          <SentryUserFeedbackModal />
        </div>
      </>
    );
  }

  return <ErrorInfo error={error} info={{ componentStack }} />;
};

export default SentryFallback;
